// extracted by mini-css-extract-plugin
export default {"header":"BlogPage_header__gqw4D","title":"BlogPage_title__45MVU","content":"BlogPage_content__N0A+G","container":"BlogPage_container__DKjQU","text":"BlogPage_text__s7PeS"};